import React, { lazy, Suspense, useEffect, useState } from 'react';

import type { ActionContext } from '@atlassian/native-embeds-core/types/action-context';

import { DATA_FETCH_FEATURE } from '../data-fetch-protocol';
import { waitForChannelFeature } from '../use-native-embed-channel/feature';

// Keep the dropdown and button out of every page that registers this manifest.
const DataFetchControl = lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/native-embeds-avpviz-experience/data-fetch-control" */ '../data-fetch-control'
	).then(({ DataFetchControl: Control }) => ({ default: Control })),
);

/**
 * Downloads and renders the data control only once the child agrees to `DATA_FETCH_FEATURE`,
 * so embeds whose child cannot use it never fetch the chunk.
 */
export function DataFetchControlLoader({
	context,
}: {
	context: ActionContext;
}): JSX.Element | null {
	const [isSupported, setSupported] = useState(false);

	useEffect(() => {
		setSupported(false);
		let active = true;
		void waitForChannelFeature(context, DATA_FETCH_FEATURE).then((isAgreed) => {
			if (active && isAgreed) {
				setSupported(true);
			}
		});
		return () => {
			active = false;
		};
	}, [context]);

	if (!isSupported) {
		return null;
	}
	return (
		<Suspense fallback={null}>
			<DataFetchControl context={context} />
		</Suspense>
	);
}
